<script>
	import appConfig from '@src/app.config'
	import Layout from '@layouts/_main'
	import PageHeader from '@components/page-header'

	import { customerEndpointApi } from '@router/apiFiles/customerEndpointApi'
	
	export default {
		page: {
			title: 'Update Customer Endpoint',
			meta: [{ name: 'description', content: appConfig.description }],
		},
		components: {
			Layout,
			PageHeader,
		},
		data() {
			return {
                items: [
                    {
                        text: 'OnBoard',
                        href: '/',
                    },
                    {
                        text: 'Customers',
                        href: '/',
                    },
                    {
                        text: 'Update',
                        active: true,
                    },
				],
                isBusy: true,
                customerEndpoint: {},
			}
		},
        props: {
            number: {
                type: String,
                default: null
            }
		},
		computed: {
			orderIsValid() {
            },
        },
		mounted() {
			this.fetchData().catch(error => {
				console.error(error)
			})
		},
		methods: {
			async fetchData() {
				var self = this;
				self.isBusy = true;
				customerEndpointApi.getCustomerEndpoint({ id: self.$route.params.id })
					.then(function (data) {
						self.customerEndpoint = data;
						self.isBusy = false;
					});					
			},		
            save() {

				/*
				id, name, endpoint, endpointToken
				*/

				var self = this;
				self.isBusy = true;
				self.show = false;
				customerEndpointApi.updateCustomerEndpoint({ 
					id: self.$route.params.id,
					name:self.customerEndpoint.name,
					endpoint: self.customerEndpoint.endpoint,
                    endpointToken: self.customerEndpoint.endpointToken,
				 })
					.then(function (data) {
						self.isBusy = false;
						self.$router.push('/searchcustomersendpoint');
					});
			},

		}
	}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<b-overlay :show="isBusy">
			<div class="row">

				<div class="col-lg-6">
					<div class="card">
						<div class="card-body">
							<h4 class="header-title mb-3">Update Customer Endpoint</h4>
														
							<div class="row">
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Name</h5>
										<b-form-input v-model="customerEndpoint.name"></b-form-input>
									</div>
								</div>
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Customer</h5>
										<b-form-input readonly v-model="customerEndpoint.customerName"></b-form-input>
									</div>
								</div>								
							</div>
							
							<div class="row">
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Endpoint</h5>
										<b-form-input v-model="customerEndpoint.endpoint"></b-form-input>
									</div>
								</div>
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Endpoint Token</h5>
										<b-form-input v-model="customerEndpoint.endpointToken"></b-form-input>
									</div>
								</div>								
							</div>
							
							<div class="row">
								<div class="col-lg-12">
									<a href="javascript: void(0);" @click="save()" class="btn btn-primary btn-sm float-right">Save<i class="uil uil-edit ml-1"></i></a>
								</div>
							</div>

						</div>
					</div>
				</div>
				
			</div>


		</b-overlay>
	</Layout>
</template>
